export default {
      id: "starFill-usage",
      viewBox: "0 0 32 30",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#starFill-usage",
      toString: function () {
        return this.url;
      }
    }